import { render, staticRenderFns } from "./MothersDay.vue?vue&type=template&id=04e39937&scoped=true&"
import script from "./MothersDay.vue?vue&type=script&lang=js&"
export * from "./MothersDay.vue?vue&type=script&lang=js&"
import style0 from "./MothersDay.vue?vue&type=style&index=0&id=04e39937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e39937",
  null
  
)

export default component.exports